import type { GameLocale } from "./types";

export type MessageKey =
  | "gameTitle"
  | "notEnoughLetters"
  | "wordNotFound"
  | "statsTitle"
  | "statsPlayed"
  | "statsWinPct"
  | "statsCurrentStreak"
  | "statsMaxStreak"
  | "winTitle"
  | "winSubtitle"
  | "loseTitle"
  | "wordWas"
  | "shareResult"
  | "close"
  | "finish"
  | "themeLightAria"
  | "themeDarkAria"
  | "closeAria"
  | "infoTitle"
  | "infoIntro"
  | "infoEx1"
  | "infoEx2"
  | "infoEx3"
  | "infoCredit"
  | "keyboardEnter"
  | "keyboardDelete"
  | "shareTitleWon"
  | "shareTitleLost"
  | "shareWordWas"
  | "shareResultTitle"
  | "langSwitchDa"
  | "langSwitchNo"
  | "langSwitchAria"
  | "keyboardAria";

const da: Record<MessageKey, string> = {
  gameTitle: "Wørdle",
  notEnoughLetters: "Ikke nok bogstaver",
  wordNotFound: "Ordet findes ikke",
  statsTitle: "Statistik",
  statsPlayed: "Spil spillet",
  statsWinPct: "Vinde %",
  statsCurrentStreak: "Nuværende stime",
  statsMaxStreak: "Bedste stime",
  winTitle: "Du vandt!",
  winSubtitle: "Godt klaret.",
  loseTitle: "Du tabte!",
  wordWas: "Ordet var:",
  shareResult: "Del resultat",
  close: "Afslut",
  finish: "Afslut",
  themeLightAria: "Skift til mørkt tema",
  themeDarkAria: "Skift til lyst tema",
  closeAria: "Luk",
  infoTitle: "Sådan spiller du",
  infoIntro: "Gæt ordet på 6 forsøg. Efter hvert gæt viser farverne hvor tæt du er.",
  infoEx1: "er i ordet og på den rigtige plads.",
  infoEx2: "er i ordet, men på en forkert plads.",
  infoEx3: "er ikke i ordet.",
  infoCredit: "Baseret på",
  keyboardEnter: "Enter",
  keyboardDelete: "Slet",
  shareTitleWon: "Dansk Wordle ✅",
  shareTitleLost: "Dansk Wordle ❌",
  shareWordWas: "Ordet var:",
  shareResultTitle: "Dansk Wordle Resultat",
  langSwitchDa: "DA",
  langSwitchNo: "NO",
  langSwitchAria: "Skift sprog",
  keyboardAria: "Tastatur – dansk layout med Æ, Ø og Å",
};

const no: Record<MessageKey, string> = {
  gameTitle: "Wordle",
  notEnoughLetters: "For få bokstaver",
  wordNotFound: "Ordet finnes ikke",
  statsTitle: "Statistikk",
  statsPlayed: "Spill spilt",
  statsWinPct: "Seier %",
  statsCurrentStreak: "Nåværende rekke",
  statsMaxStreak: "Beste rekke",
  winTitle: "Du vant!",
  winSubtitle: "Bra jobbet.",
  loseTitle: "Du tapte!",
  wordWas: "Ordet var:",
  shareResult: "Del resultat",
  close: "Lukk",
  finish: "Lukk",
  themeLightAria: "Bytt til mørkt tema",
  themeDarkAria: "Bytt til lyst tema",
  closeAria: "Lukk",
  infoTitle: "Slik spiller du",
  infoIntro: "Gjett ordet på 6 forsøk. Etter hvert gjett viser fargene hvor nær du er.",
  infoEx1: "er i ordet og på riktig plass.",
  infoEx2: "er i ordet, men på feil plass.",
  infoEx3: "er ikke i ordet.",
  infoCredit: "Basert på",
  keyboardEnter: "Enter",
  keyboardDelete: "Slett",
  shareTitleWon: "Wordle ✅",
  shareTitleLost: "Wordle ❌",
  shareWordWas: "Ordet var:",
  shareResultTitle: "Wordle",
  langSwitchDa: "DA",
  langSwitchNo: "NO",
  langSwitchAria: "Bytt språk",
  keyboardAria: "Tastatur – norsk layout med Æ, Ø og Å (samme som nordisk standard)",
};

export const messages: Record<GameLocale, Record<MessageKey, string>> = {
  da,
  no,
};

export function getMessages(locale: GameLocale): Record<MessageKey, string> {
  return messages[locale];
}
